import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Loader, Dimmer } from "semantic-ui-react";
import moment from "moment";
import axios from "axios";
import { formatMoneda, formatoMonto, round, seleccionarCampo, validaMonto, validarCantidad, validarCantidaddos } from "../../util/varios";
import { Mensaje, MensajeSiNo } from "../mensajes";
import useTableScroll from "../useTableScroll";
import { TableBody, TableRow, TableCell } from "@material-ui/core";
import { ModalIncluirRetencion } from "./modalIncluirRetencion";
import { format } from "crypto-js";

const TablaRetencionesporCobrar = (props) => {
  const op = require("../../../public/modulos/datos");
  const token = sessionStorage.getItem("jwtToken");
  const anioActu = JSON.parse(sessionStorage.getItem("anioactu"));
  const idVendedor = JSON.parse(sessionStorage.getItem("idagente"));
  const afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));
  const fechasistema = JSON.parse(sessionStorage.getItem("fechasistema"));
  const accbtncntxcobrar = JSON.parse(
    sessionStorage.getItem("accbtncntxcobrarc")
  );
  const cmbCedula = ["J", "V", "G", "P"];
  const headCells = [
    { label: "CODIGO", textAlign: "center", width: "50px" },
    { label: "DESCRIPCION", textAlign: "center", width: "200px" },
    { label: "BASE IMPONIBLE", textAlign: "center", width: "80px" },
    { label: "ALICUOTA", textAlign: "center", width: "80px" },
    { label: "TOTAL RETENIDO", textAlign: "center", width: "80px" },
    { label: "---", textAlign: "center", width: "50px" },
  ];

  const txtCliente = useRef();
  const txtFecha = useRef();
  const txtDevuelto = useRef([]);
  const txtCantidad = useRef([]);
  const txtPendientes = useRef();
  const btnAcepta = useRef();
  const btnCancela = useRef();
  const cmbRif = useRef();
  const txtRif = useRef();
  const txtNotaEntrega = useRef();
  const txtMonto = useRef();
  const txtIva = useRef();
  const txtTMonto = useRef();
  const txtTIva = useRef();
  const txtTotalRetenido = useRef();
  const [mostrar, setMostrar] = useState(false);
  const [valnota, setValnota] = useState("");
  const [records, setRecords] = useState([]);
  const [activate, setActivate] = useState(false);
  const [body, setBody] = useState(null);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });

  const { TblContainer, TblHead } = useTableScroll(headCells);

  const blanquear = () => {
    setMostrar(false);
    setRecords([]);
    txtRif.current.value = "";
    cmbRif.current.value = "";
    txtMonto.current.value = "";
    txtNotaEntrega.current.value = "";
    txtCliente.current.value = "";
    txtTIva.current.value = "";
    txtTMonto.current.value = "";
    txtTMonto.current.value = "";
  };

  const handleCloseSi = () => {
    setActivate(false);
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  const cancelar = () => {
    blanquear();
    props.onHideCancelar();
  };

  const cerrarModal = () => {
    blanquear();
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    props.onHideCancelar();
    props.onRenderizar();
  };

  const seleccionarCliente = (id) => {
    let campos = "rif, trim(nombre) as nombre, idagente";
    let nomtab = "agente";
    let nomid = "idagente";
    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.idagente > 0) {
            cmbRif.current.value = response.data.rif.substring(0, 1);
            txtRif.current.value = response.data.rif.substring(1, 12);
            txtCliente.current.value = response.data.nombre;
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "Cliente no existe.",
              icono: "informacion",
            });
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const eliminarRetencion = (n) => (e) => {
    e.preventDefault();
    let data = [...records];
    let elementos = [];
    let totales = 0.0;

    for (let i = 0; i < data.length; i++) {
      if (n.codigo !== data[i].codigo) {
        elementos.push(data[i]);
        totales = parseFloat(totales) + parseFloat(data[i].total);
      }
    }

    txtTotalRetenido.current.value = formatMoneda(totales.toString().replace(",", "").replace(".", ","), ",", ".", 2);

    setRecords(elementos);
  };

  const onCatalogoRetenciones = (values) => {
    setMostrar(false);

    let data = [...records];
    let datos = [];
    let totalr = 0.00;
    let totales = 0.00;
    let recto = 0.00;

    for (let e = 0; e < values.length; e++) {
      totalr = parseFloat(totalr) + parseFloat(round(values[e].total, 2));
    }

    for (let i = 0; i < data.length; i++) {

      if (parseInt(records[i].codigo) === parseInt(values[0].codigo)) {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "¡ Este Tipo de Retención ya fue Seleccionada !",
          icono: "informacion",
        });
        return;
      }

      datos.push({
        alicuota: data[i].alicuota,
        baseimponible: data[i].baseimponible,
        codigo: data[i].codigo,
        descripcion: data[i].descripcion,
        fecha: data[i].fecha,
        iva: data[i].iva,
        montoiva: data[i].montoiva,
        total: data[i].total,
        totalf: data[i].totalf,
        unidad: data[i].unidad,
      });

      if (data[i].total > 0) {
        recto = parseFloat(recto) + parseFloat(data[i].total);
      }
      
    }

    datos.push({
      alicuota: values[0].alicuota,
      baseimponible: values[0].baseimponible,
      codigo: values[0].codigo,
      descripcion: values[0].descripcion,
      fecha: values[0].fecha,
      iva: values[0].iva,
      montoiva: values[0].montoiva,
      total: values[0].total,
      totalf: values[0].totalf,
      unidad: values[0].unidad,
    });

    txtFecha.current.value = moment(values[0].fecha).format('DD/MM/YYYY');

    totales = recto > 0 ? recto + totalr : totalr;
    txtTotalRetenido.current.value = formatMoneda(totales.toString().replace(",", "").replace(".", ","), ",", ".", 2);
    setRecords(datos);
  };

  const onChangeValidar = (e) => {
    e.preventDefault();

    let sigue = true;
    if (props.ope === 10) {
      if (records.length > 0) {
        sigue = true;
      } else {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "¡ Error de Transacción !",
          icono: "informacion",
        });
        sigue = false;
      }

      if (sigue === true) {
        let data = [];

        for (let i = 0; i < records.length; i++) {
          
          data.push({
            fecha: records[i].fecha,
            monto: round(records[i].total, 2),
            formapago: 10,
            referencia: "",
            tipodivisa: 0,
            simbolo: "$",
            notacredito: "",
            idbanco: "",
            valormoneda: 0,
            descripcion: "Retención ("+records[i].descripcion+")",
            codigo: records[i].codigo,
            porc: records[i].alicuota
          });
          
        }  

        if (data.length > 0) {
          props.onHideAceptaData(data);
          props.onHideCancelar();
          blanquear();
        }

      }
    }
  };

  return (
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      size="xl"
      backdrop="static"
      keyboard={false}
      onShow={() => {
        if (props.ope === 10) {

          seleccionarCliente(props.idclient);
          let numfactu = props.numfact.substring(0, 2);
          setValnota(numfactu);
          txtNotaEntrega.current.value = props.numfact;
          txtMonto.current.value = formatMoneda(props.montonota.toString().replace(",", "").replace(".", ","), ",", ".", 2);
          txtIva.current.value = formatMoneda(props.montoiva.toString().replace(",", "").replace(".", ","), ",", ".", 2);
          txtTMonto.current.value = formatMoneda(props.montonota.toString().replace(",", "").replace(".", ","), ",", ".", 2);
          txtTIva.current.value = formatMoneda(props.montoiva.toString().replace(",", "").replace(".", ","), ",", ".", 2);
        }
      }}
    >
      <Modal.Header className="azulGradiant2 header-modal">
        <div className="fw-bold text-light">
          <h3>Gestionar Retenciones</h3>
        </div>
        <button
          ref={btnCancela}
          className="bg-transparent"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <div style={{ height: "100%", width: "100%" }}>
          <div className="row col-md-12" style={{ margin: 0 }}>
            <div className="col-md-12 row border-azul mx-auto rounded py-1">

              <div className="col-pd-350">
                <div className="input-group input-group-sm mb-2 px-1">
                  <label
                    className="input-group-text"
                    id="inputGroup-sizing-sm"
                  >
                    {valnota === "NE" ? "N° NOTA DE ENTREGA:" : "N° NOTA DE DEBITO:"}
                  </label>
                  <input
                    disabled={true}
                    autoComplete="off"
                    type="text"
                    className="form-control fs-6"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    ref={txtNotaEntrega}
                  />
                </div>
              </div>
              <input type="hidden" ref={txtFecha} />
              <div className="col-pd-350 mx-auto">
                <div className="input-group input-group-sm mb-2 px-1">
                  <label
                    className="input-group-text"
                    id="inputGroup-sizing-sm"
                  >
                    {valnota === "NE" ? "MONTO (NOTA DE ENTREGA):" : "MONTO (NOTA DE DEBITO):"}
                  </label>
                  <input
                    disabled={true}
                    autoComplete="off"
                    type="text"
                    className="form-control fs-6 text-right"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    ref={txtMonto}
                  />
                </div>
              </div>

              <div className="col-pd-220">
                <div className="input-group input-group-sm mb-2 px-1">
                  <label
                    className="input-group-text"
                    id="inputGroup-sizing-sm"
                  >
                    MONTO IVA:
                  </label>
                  <input
                    disabled={true}
                    autoComplete="off"
                    type="text"
                    className="form-control fs-6 text-right"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    ref={txtIva}
                  />
                </div>
              </div>

              <div
                className="col-12 mx-auto mb-1 "
                style={{ fontSizeAdjust: "0.6" }}
              >
                <div className="col-md-12 mx-auto row border-azul rounded py-2">

                  <span className="fw-bold mb-1">Datos del Cliente</span>
                  <div className="input-group input-group-sm mb-2 col-3 px-2">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      CEDULA/RIF:{" "}
                    </label>
                    <select
                      ref={cmbRif}
                      name="cmbrif"
                      disabled
                      className="form-select form-select-sm col-md-3 text-center"
                      aria-label=".form-select-sm example"
                    >
                      <option value="">--</option>
                      {cmbCedula &&
                        cmbCedula.map((item, index) => (
                          <option key={index} value={item}>
                            {item}
                          </option>
                        ))}
                    </select>
                    <input
                      ref={txtRif}
                      autoComplete="off"
                      disabled
                      maxLength={12}
                      type="text"
                      className="form-control fs-6 px-1"
                      name="cedula"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                    />
                  </div>
                  <div className="input-group input-group-sm mb-2 col-9 px-0">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      NOMBRE:{" "}
                    </label>
                    <input
                      disabled
                      autoComplete="off"
                      type="text"
                      className="form-control fs-6"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      ref={txtCliente}
                    />
                  </div>
                </div>
              </div>

              <div
                className="col-pd-957 border-azul px-0 rounded"
                style={{ backgroundColor: "#d5e9ff" }}
              >
                <TblContainer
                  container={{
                    height: 190,
                    width: "100%",
                    overflow: "auto",
                    padding: "2px",
                    fontSizeAdjust: "0.6",
                  }}
                >
                  <TblHead />
                  <TableBody className="overflow-hidden">
                    {records &&
                      records.map((item, index) => (
                        <TableRow key={index} style={{ padding: "0" }}>
                          <TableCell className="align-middle bg-light text-center p-0">
                            {item.codigo}
                          </TableCell>

                          <TableCell
                            className="align-middle bg-light p-0 pl-2"
                            style={{ width: "200px" }}
                          >
                            {item.descripcion}
                          </TableCell>
                          <TableCell
                            className="align-middle bg-light text-right p-0"
                            style={{ width: "80px" }}
                          >
                            {formatMoneda(
                              item.baseimponible
                                .toString()
                                .replace(",", "")
                                .replace(".", ","),
                              ",",
                              ".",
                              2
                            )}
                          </TableCell>
                          <TableCell
                            className="align-middle bg-light text-end p-0 pr-2"
                            style={{ width: "80px" }}
                          >
                            {formatMoneda(
                              item.alicuota
                                .toString()
                                .replace(",", "")
                                .replace(".", ","),
                              ",",
                              ".",
                              2
                            )}
                          </TableCell>

                          <TableCell
                            className="align-middle bg-light text-end p-0 pr-2"
                            style={{ width: "80px" }}
                          >
                            {formatMoneda(
                              item.total
                                .toString()
                                .replace(",", "")
                                .replace(".", ","),
                              ",",
                              ".",
                              2
                            )}
                          </TableCell>
                          <TableCell
                            className="align-middle bg-light"
                            style={{
                              textAlign: "center",
                              alignItems: "center",
                              width: "50px",
                            }}
                          >
                            <button
                              className="btn btn-sm mx-1 btn-danger rounded"
                              onClick={eliminarRetencion(item)}
                            >
                              <i className="fa fa-trash" />
                            </button>
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </TblContainer>
              </div>
              <div className="col-pd-120 border-azul px-0 rounded ml-auto border-4">
                <div className="col-pd-100 h-50p"></div>
                <div className="col-pd-100 mx-auto mb-2 px-1">
                  <button
                    onClick={() => { setMostrar(true); }}
                    className="btn btn-sm btn-primary rounded h-40p"
                  >
                    <i className="fas fa-plus"> INCLUIR</i>{" "}
                  </button>
                </div>
              </div>
              <div className="col-md-4 border-azul px-0 rounded ml-auto border-4">
                <div className="input-group input-group-sm col px-0 ml-auto m-0">
                  <label
                    className="input-group-text bg-transparent border-0 fw-bold col-4 text-right"
                    id="inputGroup-sizing-sm"
                  >
                    TOTAL NOTA:{" "}
                  </label>
                  <input
                    disabled
                    autoComplete="off"
                    type="text"
                    className="form-control fs-5 h-100 text-right"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    ref={txtTMonto}
                  />
                </div>
                <div className="input-group input-group-sm col px-0 ml-auto m-0">
                  <label
                    className="input-group-text bg-transparent border-0 fw-bold col-4 text-right"
                    id="inputGroup-sizing-sm"
                  >
                    TOTAL IVA:{" "}
                  </label>
                  <input
                    disabled
                    autoComplete="off"
                    type="text"
                    className="form-control fs-5 h-100 text-right"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    ref={txtTIva}
                  />
                </div>
                <div className="input-group input-group-sm col px-0 ml-auto m-0">
                  <label
                    className="input-group-text bg-transparent border-0 fw-bold col-4 text-right"
                    id="inputGroup-sizing-sm"
                  >
                    TOTAL RETENIDO:{" "}
                  </label>
                  <input
                    disabled
                    autoComplete="off"
                    type="text"
                    className="form-control fs-5 h-100 text-right"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    placeholder="0,00"
                    ref={txtTotalRetenido}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btn btn-sm btn-success rounded-pill"
          onClick={onChangeValidar}
          ref={btnAcepta}
          style={{ margin: "5px" }}
        >
          <i className="fas fa-check-circle"> Procesar</i>{" "}
        </button>
        <button
          ref={btnCancela}
          onClick={cancelar}
          className="btn btn-sm btn-danger rounded-pill"
        >
          <i className="fas fa-window-close"> Cancelar</i>
        </button>
      </Modal.Footer>
      <ModalIncluirRetencion
        show={mostrar}
        monto={props.montonota}
        montiva={props.montoiva}
        iva={props.ivas}
        operacion={1}
        data={records}
        valiva={valnota}
        onHideCancelar={() => setMostrar(false)}
        onHideAceptaCatalogo={onCatalogoRetenciones}
      />
      <Dimmer active={activate} inverted>
        <Loader inverted>Cargando...</Loader>
      </Dimmer>
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? cerrarModal()
            : setMensaje({
              mostrar: false,
              titulo: "",
              texto: "",
              icono: "",
            });
        }}
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
    </Modal>
  );
};
export default TablaRetencionesporCobrar;



// WEBPACK FOOTER //
// ./src/components/finanzas/tablaRetencionesxCobrar.js